import React from "react";
import {
  name,
  ApiEndpoint,
  platform,
  feedbackInputLimit,
  summaryInputLimit,
} from "../Constant";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import * as axios from "axios";
import $ from "jquery";

// Initialize an agent at application startup.
const fpPromise = FingerprintJS.load();

export const FingerPrint = async (type = "visitor") => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  if (type === "visitor") {
    return result.visitorId;
  } else {
    //return result.visitorId;
  }
};

/*FingerPrint().then(function(result){
  const DeviceSid = result;
});*/

export const UpdateState = (elem, key, value) => {
  if (value != getState(elem, key)) {
    elem.setState({ [key]: value });
  }
};

export const getState = (elem, key) => {
  return elem.state[key];
};

export const setChange = (elem, key, value) => {
  if (getChange(elem, key) != value && value != "") {
    value = trimSpaces(value);
    elem.setState({ [key]: value });
  }
};

export const getChange = (elem, key) => {
  return elem.state[key];
};

export const validateEmail = (email) => {
  let re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const trimSpaces = (text) => {
  if (text != "" && text != "") {
    return text.toString().trim();
  } else {
    return "";
  }
};

export const BreedForm = (props) => {
  return <div className="breed-form-x">{props.children}</div>;
};

export const AlertMessage = (elem, message, classX) => {
  UpdateState(elem, "message", { text: message, css: classX });
};

export const AlertMessageOut = (elem) => {
  window.scrollTo(0, 0);
  $(".reg-loading").addClass("hide");
  $(".reg-btn").removeClass("hide");

  let msg = getState(elem, "message");
  if (msg != "") {
    let msgx = JSON.parse(JSON.stringify(msg));
    if (msgx.text != "" && msgx.css != "") {
      return (
        <div className="form-group-lg">
          <div className={msgx.css}>{msgx.text}</div>
        </div>
      );
    }
  }
};

export const serializeArray = (obj) => {
  return new Array(JSON.parse(JSON.stringify(obj)));
};

export const TimeZone = () => {
  let tz =
    getSession("timezone") != "" &&
    getSession("timezone") !== false &&
    getSession("timezone") !== null
      ? getSession("timezone")
      : "America/New_York";
  return tz;
};

export const MyTimeZone = () => {
  return new Date()
    .toLocaleDateString(undefined, { day: "2-digit", timeZoneName: "short" })
    .substring(4);
};

export const Time = (timezone = "") => {
  let tz = TimeZone();
  let timezonez = timezone != "" ? timezone : tz;
  let d = new Date(new Date().toLocaleString("en-US", { timeZone: timezonez }));
  return Math.floor(d.getTime() / 1000);
  //return Math.floor(new Date().getTime() / 1000);
};

export const DateTime = (UNIX_timestamp) => {
  var a = new Date(UNIX_timestamp * 1000);
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var asset = ["AM", "PM"];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time =
    date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
  return time;
};

// toggle to switch classes between .light and .dark
// if no class is present (initial state), then assume current state based on system color scheme
// if system color scheme is not supported, then assume current state is light
export const toggleDarkMode = () => {
  if (
    (window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches) ||
    localStorage.getItem("theme") == "dark"
  ) {
    document.documentElement.classList.add("dark");
    let drklteCheck =
      document.getElementById("drk-lte-switch-check") || document.createElement;
    let togContainer =
      document.getElementById("toggle-container") || document.createElement;
    let togInputContainer =
      document.getElementById("switch-theme") || document.createElement;

    drklteCheck?.classList?.remove("light");
    togContainer?.classList?.remove("light");
    drklteCheck.checked = true;
    togInputContainer.checked = true;
  } else {
    document.documentElement.classList.add("light");
  }

  return true;
};

export const toggleDarkModeX = () => {
  let drklteCheck = document.querySelector(".drk-lte-switch-check");
  let togContainer = document.querySelector(".toggle-container");
  drklteCheck.classList.toggle("light");
  togContainer.classList.toggle("light");
  if (document.documentElement.classList.contains("light")) {
    document.documentElement.classList.remove("light");
    document.documentElement.classList.add("dark");
    localStorage.setItem("theme", "dark");
  } else if (document.documentElement.classList.contains("dark")) {
    document.documentElement.classList.remove("dark");
    document.documentElement.classList.add("light");
    localStorage.setItem("theme", "light");
  } else {
    if (
      (window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches) ||
      localStorage.getItem("theme") == "dark"
    ) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.add("light");
      localStorage.setItem("theme", "light");
    }
  }

  return true;
};

export const RedirectNotLogin = () => {
  if (
    JSON.parse(getSession("login")) !== true ||
    JSON.parse(getSession("login_valid")) < Time()
  ) {
    clearSession();
    window.location.href = "/login";
  }
};

export const RedirectIfLogin = () => {
  if (
    JSON.parse(getSession("login")) === true &&
    JSON.parse(getSession("login_valid")) > Time()
  ) {
    window.location.href = "/dashboard";
  }
};

export const RedirectContractor = () => {
  if (
    JSON.parse(getSession("contractor")) === 1 &&
    JSON.parse(getSession("contractor")) > 0
  ) {
    window.location.href = "/dashboard";
  }
};

export const RedirectNotContractor = () => {
  if (
    JSON.parse(getSession("contractor")) === 0 &&
    JSON.parse(getSession("contractor")) < 1
  ) {
    window.location.href = "/dashboard";
  }
};

export const RedirectNotReviewerOrEditor = () => {
  if (
    (getSession("reviewer") && getSession("reviewer") > 0) ||
    (getSession("editor") && getSession("editor") > 0)
  ) {
    //Do Nothing
  } else {
    window.location.href = "/dashboard";
  }
};

export const setSession = (key, value) => {
  if (key != "" && value != "") {
    return window.localStorage.setItem(key, value);
  }
  return false;
};

export const getSession = (key) => {
  if (key != "") {
    return window.localStorage.getItem(key);
  }
  return false;
};

export const removeSession = (key) => {
  if (key != "") {
    return window.localStorage.removeItem(key);
  }
  return false;
};

export const clearSession = () => {
  return window.localStorage.clear();
};

export const handleSubmit = (elem, target) => {
  UpdateState(elem, "message", "");
  UpdateState(elem, "loading", "1");

  switch (target) {
    case "login":
      doLogin(elem);
      break;

    case "register":
      window.setTimeout(function () {
        $(".reg-btn").addClass("hide");
        $(".reg-loading").removeClass("hide");

        doRegister(elem);
      }, 2000);

      break;

    case "updateaccount":
      doUpdateAccount(elem);
      break;

    case "updatefield":
      doUpdateField(elem);
      break;

    case "updaterole":
      doUpdateRole(elem);
      break;

    case "changepassword":
      doChangePassword(elem);
      break;

    case "recover":
      doRecover(elem);
      break;

    case "reset":
      doReset(elem);
      break;

    case "edit_details":
      doEditDetails(elem);
      break;

    case "submit_file":
      doSubmitFile(elem);
      break;

    case "resubmit_file":
      doResubmitFile(elem);
      break;

    case "upload_repo_file":
      doUploadRepoFile(elem);
      break;

    case "add_paypal_email":
      doAddPayPalEmail(elem);
      break;

    case "logout":
      doLogout();
      break;

    case "toggleNav":
      doToggleNav();
      break;

    default:
      alert("Unknown Command");
      UpdateState(elem, "message", "");
      UpdateState(elem, "loading", "0");
      break;
  }
};

export const popModal = (size, data) => {
  $(document).find("#response-message").addClass("hide");
  $(".modal-content-overlay").addClass("show-modal");
  if (size === "small") {
    $(".modal-large").removeClass("show-modal");
    $(".modal-small").addClass("show-modal");
    $(".small-modal-data-title").text(data["title"]);
    $(".small-modal-data-body").html(data["body"]);
  } else {
    $(".modal-small").removeClass("show-modal");
    $(".modal-large").addClass("show-modal");
    $(".large-modal-data-title").text(data["title"]);
    $(".large-modal-data-body").html(data["body"]);
  }
};

export const setHTML = (html) => {
  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
    </>
  );
};

export const doToggleNav = () => {
  var menu = document.querySelector(".dash-aside"); // Using a class instead, see note below.
  menu.classList.toggle("hide-mobile");
};

export const doLogout = () => {
  clearSession();
  window.location.href = "/login";
};

export const doEditDetails = async (elem) => {
  let DeviceSid = await FingerPrint();

  let editDetailsError = "";
  let classError = "";

  if (getState(elem, "publishing_status") == "") {
    editDetailsError = "Publishing Status is required";
  } else if (getState(elem, "publication_date") == "") {
    editDetailsError = "Publication Date is required";
  } else if (getState(elem, "volume") == "") {
    editDetailsError = "Volume is required";
  } else if (getState(elem, "issue_number") == "") {
    editDetailsError = "Issue Number is required";
  } else if (getState(elem, "pages_number") == "") {
    editDetailsError = "Pages Number is required";
  } else if (getState(elem, "issn") == "") {
    editDetailsError = "ISSN is required";
  } else if (getState(elem, "scriptID") == "") {
    editDetailsError = "Script ID is required";
  } else if (getState(elem, "note") == "") {
    //editDetailsError = "Note is required";
  }

  if (editDetailsError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "editdetails",
      user_id: getSession("userID"),
      scriptID: getState(elem, "scriptID"),
      publishing_status: getState(elem, "publishing_status"),
      publication_date: getState(elem, "publication_date"),
      volume: getState(elem, "volume"),
      issue_number: getState(elem, "issue_number"),
      pages_number: getState(elem, "pages_number"),
      issn: getState(elem, "issn"),
      note: getState(elem, "note"),
    };

    axios
      .post(ApiEndpoint + "/editdetails?q=doEditDetails", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");

          setTimeout(function () {
            window.location.href = "/details";
          }, 15000);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, editDetailsError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doReportFeedback = async (
  elem,
  reportFeedback,
  scriptID,
  feedbackID
) => {
  //UpdateState(elem, 'loading', '1');

  $(document).find("#submit-feedback-report").addClass("disabled");
  $(document).find("#submit-feedback-report").prop("disabled", true);

  let DeviceSid = await FingerPrint();

  let reportError = "";
  let classError = "";

  if (typeof reportFeedback === "undefined" || reportFeedback == "") {
    reportError =
      "Please provide the reason why you are reporting this feedback";
  } else if (typeof scriptID === "undefined" || scriptID == "") {
    reportError = "Script ID is required";
  } else if (typeof feedbackID === "undefined" || feedbackID == "") {
    reportError = "Feedback ID is required";
  }

  if (reportError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        //'Content-Type': "multipart/form-data",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "report_feedback",
      user_id: getSession("userID"),
      scriptID: scriptID,
      report_message: reportFeedback,
      feedback_id: feedbackID,
    };

    axios
      .post(ApiEndpoint + "/report_feedback?q=doSubmit", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          //AlertMessage(elem, response?.data?.message, 'success');

          setTimeout(function () {
            window.location.reload();
          }, 5000);

          $(document).find("#response-message").html(response?.data?.message);
          $(document).find("#response-message").removeClass("error");
          $(document).find("#response-message").addClass("success");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#submit-feedback-report").addClass("disabled");
          $(document).find("#submit-feedback-report").prop("disabled", true);
        } else if (response?.data?.error != false) {
          //AlertMessage(elem, response?.data?.error, 'error');

          $(document).find("#response-message").html(response?.data?.error);
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#submit-feedback-report").removeClass("disabled");
          $(document).find("#submit-feedback-report").prop("disabled", false);

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 20000);
          }
        } else {
          //AlertMessage(elem, "Something went wrong, try again or try to reload the page!", 'error');
          $(document)
            .find("#response-message")
            .html("Something went wrong, try again or try to reload the page!");
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#submit-feedback-report").removeClass("disabled");
          $(document).find("#submit-feedback-report").prop("disabled", false);
        }
      })
      .catch((err) => {
        //AlertMessage(elem, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
        $(document)
          .find("#response-message")
          .html(
            "Something went wrong, try again or try to reload the page!\n\r" +
              err
          );
        $(document).find("#response-message").removeClass("success");
        $(document).find("#response-message").addClass("error");
        $(document).find("#response-message").removeClass("hide");

        $(document).find("#submit-feedback-report").removeClass("disabled");
        $(document).find("#submit-feedback-report").prop("disabled", false);

        //UpdateState(elem, 'loading', '0');
      });
  } else {
    //AlertMessage(elem, reviewError, 'error');
    $(document).find("#response-message").html(reportError);
    $(document).find("#response-message").removeClass("success");
    $(document).find("#response-message").addClass("error");
    $(document).find("#response-message").removeClass("hide");

    $(document).find("#submit-feedback-report").removeClass("disabled");
    $(document).find("#submit-feedback-report").prop("disabled", false);

    //UpdateState(elem, 'loading', '0');
  }
};

export const doInviteExternalReviewer = async (
  elem,
  reviewerFullName,
  reviewerEmail,
  scriptID
) => {
  $(document).find("#submit-external-reviewer").addClass("disabled");
  $(document).find("#submit-external-reviewer").prop("disabled", true);

  let DeviceSid = await FingerPrint();

  let reviewerError = "";
  let classError = "";

  if (typeof reviewerEmail === "undefined" || reviewerEmail == "") {
    reviewerError = "Please provide reviewer email";
  } else if (typeof scriptID === "undefined" || scriptID == "") {
    reviewerError = "Script ID is required";
  }

  if (reviewerError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "invite_reviewer",
      user_id: getSession("userID"),
      scriptID: scriptID,
      reviewerFullName: reviewerFullName,
      reviewer_email: reviewerEmail,
    };

    // console.log("got here");

    axios
      .post(ApiEndpoint + "/invite_reviewer?q=doSubmit", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          setTimeout(function () {
            window.location.reload();
          }, 5000);

          $(document).find("#response-message").html(response?.data?.message);
          $(document).find("#response-message").removeClass("error");
          $(document).find("#response-message").addClass("success");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#submit-feedback-report").addClass("disabled");
          $(document).find("#submit-feedback-report").prop("disabled", true);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          $(document).find("#response-message").html(response?.data?.error);
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#submit-feedback-report").removeClass("disabled");
          $(document).find("#submit-feedback-report").prop("disabled", false);

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 20000);
          }
        } else {
          //AlertMessage(elem, "Something went wrong, try again or try to reload the page!", 'error');
          $(document)
            .find("#response-message")
            .html("Something went wrong, try again or try to reload the page!");
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#submit-external-reviewer").removeClass("disabled");
          $(document).find("#submit-external-reviewer").prop("disabled", false);
        }
      })
      .catch((err) => {
        //AlertMessage(elem, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
        $(document)
          .find("#response-message")
          .html(
            "Something went wrong, try again or try to reload the page!\n\r" +
              err
          );
        $(document).find("#response-message").removeClass("success");
        $(document).find("#response-message").addClass("error");
        $(document).find("#response-message").removeClass("hide");

        $(document).find("#submit-external-reviewer").removeClass("disabled");
        $(document).find("#submit-external-reviewer").prop("disabled", false);

        //UpdateState(elem, 'loading', '0');
      });
  } else {
    //AlertMessage(elem, reviewError, 'error');
    $(document).find("#response-message").html(reviewerError);
    $(document).find("#response-message").removeClass("success");
    $(document).find("#response-message").addClass("error");
    $(document).find("#response-message").removeClass("hide");

    $(document).find("#submit-external-reviewer").removeClass("disabled");
    $(document).find("#submit-external-reviewer").prop("disabled", false);

    //UpdateState(elem, 'loading', '0');
  }
};

export const doReviewCommit = async (
  elem,
  commitPledge,
  scriptID,
  commitPledgeConfirmation
) => {
  //UpdateState(elem, 'loading', '1');

  $(document).find("#commit-script").addClass("disabled");
  $(document).find("#commit-script").prop("disabled", true);

  let DeviceSid = await FingerPrint();

  let reviewError = "";
  let classError = "";

  if (commitPledge != "0" && commitPledge != "1") {
    reviewError = "Please select to commit as either Editor or Reviewer";
  } else if (commitPledgeConfirmation != "1") {
    reviewError = "Please accept to commit to script ID: " + scriptID;
  }

  if (reviewError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        //'Content-Type': "multipart/form-data",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "review_commit",
      user_id: getSession("userID"),
      scriptID: scriptID,
      commit_pledge: commitPledge,
      commit_pledge_confirm: commitPledgeConfirmation,
    };

    axios
      .post(ApiEndpoint + "/review_commit?q=doSubmit", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          //AlertMessage(elem, response?.data?.message, 'success');

          setTimeout(function () {
            window.location.href = "/my-commit";
          }, 5000);

          $(document).find("#response-message").html(response?.data?.message);
          $(document).find("#response-message").removeClass("error");
          $(document).find("#response-message").addClass("success");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#commit-script").addClass("disabled");
          $(document).find("#commit-script").prop("disabled", true);
        } else if (response?.data?.error != false) {
          //AlertMessage(elem, response?.data?.error, 'error');

          $(document).find("#response-message").html(response?.data?.error);
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#commit-script").removeClass("disabled");
          $(document).find("#commit-script").prop("disabled", false);

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 20000);
          }
        } else {
          //AlertMessage(elem, "Something went wrong, try again or try to reload the page!", 'error');
          $(document)
            .find("#response-message")
            .html("Something went wrong, try again or try to reload the page!");
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#commit-script").removeClass("disabled");
          $(document).find("#commit-script").prop("disabled", false);
        }
      })
      .catch((err) => {
        //AlertMessage(elem, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
        $(document)
          .find("#response-message")
          .html(
            "Something went wrong, try again or try to reload the page!\n\r" +
              err
          );
        $(document).find("#response-message").removeClass("success");
        $(document).find("#response-message").addClass("error");
        $(document).find("#response-message").removeClass("hide");

        $(document).find("#commit-script").removeClass("disabled");
        $(document).find("#commit-script").prop("disabled", false);

        //UpdateState(elem, 'loading', '0');
      });
  } else {
    //AlertMessage(elem, reviewError, 'error');
    $(document).find("#response-message").html(reviewError);
    $(document).find("#response-message").removeClass("success");
    $(document).find("#response-message").addClass("error");
    $(document).find("#response-message").removeClass("hide");

    $(document).find("#commit-script").removeClass("disabled");
    $(document).find("#commit-script").prop("disabled", false);

    //UpdateState(elem, 'loading', '0');
  }
};

export const doReviewsubmit = async (
  elem,
  feedback,
  feedbackFile,
  scriptID,
  reviewPhase,
  score
) => {
  //UpdateState(elem, 'loading', '1');

  $(document).find("#accept-file").addClass("disabled");
  $(document).find("#reject-file").addClass("disabled");
  $(document).find("#revise-file").addClass("disabled");

  $(document).find("#accept-file").prop("disabled", true);
  $(document).find("#reject-file").prop("disabled", true);
  $(document).find("#revise-file").prop("disabled", true);

  let DeviceSid = await FingerPrint();

  let reviewError = "";
  let classError = "";

  if (feedback == "") {
    reviewError = "Feedback is required";
  } else if (feedback.length > feedbackInputLimit) {
    reviewError =
      "Feedback can not exceed " + feedbackInputLimit + " characters";
  } else if (scriptID == "") {
    reviewError = "Script is required";
  } else if (reviewPhase == "") {
    reviewError = "Review phase is required";
  } else if (score == "") {
    reviewError = "Feedback Score is required";
  } else if (
    getState(elem, "editor") > 0 &&
    typeof feedbackFile === "undefined"
  ) {
    if (feedbackFile[0].name == "" || !feedbackFile[0].name) {
      reviewError = "Your must Attach a file it is required";
    }
  }

  if (reviewError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "review_feedback",
      user_id: getSession("userID"),
      scriptID: scriptID,
      review_phase: reviewPhase,
      feedback: feedback,
      score: score,
    };

    const formData = new FormData();
    formData.append("cmd", "review_feedback");
    formData.append("user_id", getSession("userID"));
    formData.append("scriptID", scriptID);
    formData.append("review_phase", reviewPhase);
    formData.append("feedback", feedback);
    formData.append("score", score);
    formData.append(
      "file",
      typeof feedbackFile !== "undefined" ? feedbackFile[0] : ""
    );

    axios
      .post(ApiEndpoint + "/review_feedback?q=doSubmit", formData, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          //AlertMessage(elem, response?.data?.message, 'success');

          setTimeout(function () {
            window.location.reload();
          }, 8000);

          $(document).find("#response-message").html(response?.data?.message);
          $(document).find("#response-message").removeClass("error");
          $(document).find("#response-message").addClass("success");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#accept-file").addClass("disabled");
          $(document).find("#reject-file").addClass("disabled");
          $(document).find("#revise-file").addClass("disabled");

          $(document).find("#accept-file").prop("disabled", true);
          $(document).find("#reject-file").prop("disabled", true);
          $(document).find("#revise-file").prop("disabled", true);
        } else if (response?.data?.error != false) {
          //AlertMessage(elem, response?.data?.error, 'error');

          $(document).find("#response-message").html(response?.data?.error);
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#accept-file").removeClass("disabled");
          $(document).find("#reject-file").removeClass("disabled");
          $(document).find("#revise-file").removeClass("disabled");

          $(document).find("#accept-file").prop("disabled", false);
          $(document).find("#reject-file").prop("disabled", false);
          $(document).find("#revise-file").prop("disabled", false);

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 20000);
          }
        } else {
          //AlertMessage(elem, "Something went wrong, try again or try to reload the page!", 'error');
          $(document)
            .find("#response-message")
            .html("Something went wrong, try again or try to reload the page!");
          $(document).find("#response-message").removeClass("success");
          $(document).find("#response-message").addClass("error");
          $(document).find("#response-message").removeClass("hide");

          $(document).find("#accept-file").removeClass("disabled");
          $(document).find("#reject-file").removeClass("disabled");
          $(document).find("#revise-file").removeClass("disabled");

          $(document).find("#accept-file").prop("disabled", false);
          $(document).find("#reject-file").prop("disabled", false);
          $(document).find("#revise-file").prop("disabled", false);
        }
      })
      .catch((err) => {
        //AlertMessage(elem, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
        $(document)
          .find("#response-message")
          .html(
            "Something went wrong, try again or try to reload the page!\n\r" +
              err
          );
        $(document).find("#response-message").removeClass("success");
        $(document).find("#response-message").addClass("error");
        $(document).find("#response-message").removeClass("hide");

        $(document).find("#accept-file").removeClass("disabled");
        $(document).find("#reject-file").removeClass("disabled");
        $(document).find("#revise-file").removeClass("disabled");

        $(document).find("#accept-file").prop("disabled", false);
        $(document).find("#reject-file").prop("disabled", false);
        $(document).find("#revise-file").prop("disabled", false);

        //UpdateState(elem, 'loading', '0');
      });
  } else {
    //AlertMessage(elem, reviewError, 'error');
    $(document).find("#response-message").html(reviewError);
    $(document).find("#response-message").removeClass("success");
    $(document).find("#response-message").addClass("error");
    $(document).find("#response-message").removeClass("hide");

    $(document).find("#accept-file").removeClass("disabled");
    $(document).find("#reject-file").removeClass("disabled");
    $(document).find("#revise-file").removeClass("disabled");

    $(document).find("#accept-file").prop("disabled", false);
    $(document).find("#reject-file").prop("disabled", false);
    $(document).find("#revise-file").prop("disabled", false);

    //UpdateState(elem, 'loading', '0');
  }
};

export const doAddPayPalEmail = async (elem) => {
  let DeviceSid = await FingerPrint();

  let submitError = "";
  let classError = "";

  if (getState(elem, "email") == "" || getState(elem, "email") == undefined) {
    submitError = "Enter your PayPal email address it is required";
  } else if (!validateEmail(getChange(elem, "email"))) {
    submitError = "PayPal email address is invalid";
  }

  if (submitError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "add_paypal_email",
      user_id: getSession("userID"),
      email: getState(elem, "email"),
    };

    const formData = new FormData();
    formData.append("cmd", "add_paypal_email");
    formData.append("user_id", getSession("userID"));
    formData.append("email", getState(elem, "email"));

    axios
      .post(ApiEndpoint + "/add_paypal_email?q=doResubmit", formData, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          //alert(response?.data?.message);
          AlertMessage(elem, response?.data?.message, "success");

          setTimeout(function () {
            window.location.reload();
          }, 15000);
        } else if (response?.data?.error != false) {
          //alert(response?.data?.error);

          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          //alert("Something went wrong, try again or try to reload the page!");
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        //alert("Something went wrong, try again or try to reload the page!\n\r"+err);
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    //alert(submitError);
    AlertMessage(elem, submitError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doSaveDownloadFile = async (elem, scriptID) => {
  let DeviceSid = await FingerPrint();

  let submitError = "";
  let classError = "";

  if (scriptID == "") {
    submitError = "Script is required";
  }

  if (submitError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "savedownload",
      user_id: getSession("userID"),
      scriptID: scriptID,
    };

    const formData = new FormData();
    formData.append("cmd", "savedownload");
    formData.append("user_id", getSession("userID"));
    formData.append("scriptID", scriptID);

    axios
      .post(ApiEndpoint + "/savedownload?q=doResubmit", formData, header)
      .then((response) => {
        //UpdateState(elem, 'loading', '0');

        if (response?.data?.error == false && response?.data?.error != true) {
          //alert(response?.data?.message);
          //AlertMessage(elem, response?.data?.message, 'success');
          /*setTimeout(function(){
        window.location.href = "/downloads";
        }, 15000);*/
        } else if (response?.data?.error != false) {
          //alert(response?.data?.error);

          //AlertMessage(elem, response?.data?.error, 'error');

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          //alert("Something went wrong, try again or try to reload the page!");
          //AlertMessage(elem, "Something went wrong, try again or try to reload the page!", 'error');
        }
      })
      .catch((err) => {
        //alert("Something went wrong, try again or try to reload the page!\n\r"+err);
        //AlertMessage(elem, "Something went wrong, try again or try to reload the page!\n\r"+err, 'error');
        //UpdateState(elem, 'loading', '0');
      });
  } else {
    //alert(submitError);
    //AlertMessage(elem, submitError, 'error');
    //UpdateState(elem, 'loading', '0');
  }
};

export const doUploadRepoFile = async (elem) => {
  let DeviceSid = await FingerPrint();

  let uploadRepoError = "";
  let classError = "";

  if (getState(elem, "title") == "") {
    uploadRepoError = "File Title is required";
  } else if (getState(elem, "desc") == "") {
    uploadRepoError = "File Description is required";
  } else if (getState(elem, "desc").length > 350) {
    uploadRepoError = "File Description must not exceed 350 characters";
  } else if (getState(elem, "file") == "") {
    uploadRepoError = "Select File to Upload it is required";
  }

  if (uploadRepoError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "uploadrepofile",
      user_id: getSession("userID"),
      title: getState(elem, "title"),
      file: getState(elem, "file"),
    };

    const formData = new FormData();
    formData.append("cmd", "uploadrepofile");
    formData.append("user_id", getSession("userID"));
    formData.append("title", getState(elem, "title"));
    formData.append("desc", getState(elem, "desc"));
    formData.append("file", getState(elem, "file"));

    axios
      .post(ApiEndpoint + "/uploadrepofile?q=doUpload", formData, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");

          setTimeout(function () {
            window.location.reload();
          }, 15000);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, uploadRepoError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doResubmitFile = async (elem) => {
  let DeviceSid = await FingerPrint();

  let resubmitError = "";
  let classError = "";

  if (getState(elem, "scriptID") == "") {
    resubmitError = "Script is required";
  } else if (getState(elem, "file") == "") {
    resubmitError = "Select Document to Upload it is required";
  }

  if (resubmitError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "resubmitfile",
      user_id: getSession("userID"),
      scriptID: getState(elem, "scriptID"),
      file: getState(elem, "file"),
    };

    const formData = new FormData();
    formData.append("cmd", "resubmitfile");
    formData.append("user_id", getSession("userID"));
    formData.append("scriptID", getState(elem, "scriptID"));
    formData.append("file", getState(elem, "file"));

    axios
      .post(ApiEndpoint + "/resubmit?q=doResubmit", formData, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");

          if (response?.data?.data != false) {
            if (response?.data?.data?.payment_inline > 0) {
              //alert(response?.data?.data?.payment_url)

              $(".paypal-frame").attr("src", response?.data?.data?.payment_url);
              $(".pp-website-link").attr(
                "href",
                response?.data?.data?.payment_url
              );

              setTimeout(function () {
                if (
                  response?.data?.data?.payment_url != "" &&
                  response?.data?.data?.payment_url != false &&
                  response?.data?.data?.payment_url != null &&
                  response?.data?.data?.payment_url != "undefined" &&
                  response?.data?.data?.payment_url != undefined
                ) {
                  $(".pp-overlay").removeClass("hidden");
                } else {
                  //DO Nothing
                }
              }, 3000);
            } else if (response?.data?.data?.payment_redirect > 0) {
              setTimeout(function () {
                window.location.href = response?.data?.data?.payment_url;
              }, 4000);
            } else {
              alert(
                "We have sent you a PayPal Payment instruction to your email address, please check your email to continue!"
              );
            }
          } else {
            setTimeout(function () {
              window.location.href = "/my-submission";
            }, 10000);
          }
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, resubmitError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doSubmitFile = async (elem) => {
  let DeviceSid = await FingerPrint();

  let submitError = "";
  let classError = "";

  if (getState(elem, "title") == "") {
    submitError = "Title is required";
  } else if (getState(elem, "summary") == "") {
    submitError = "Summary is required";
  } else if (getState(elem, "summary")?.length > summaryInputLimit) {
    submitError =
      "Summary must not exceed " + summaryInputLimit + " characters";
  } else if (getState(elem, "file") == "") {
    submitError = "Select Document to Upload it is required";
  } else if (getState(elem, "target") == "") {
    submitError = "Geo Target is required";
  } else if (getState(elem, "author") == "") {
    submitError = "Author(s) is required";
  } else if (getState(elem, "affiliate") == "") {
    //submitError = "Affiliate(s) is required";
  }

  if (submitError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        //'Content-Type': "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "submitfile",
      user_id: getSession("userID"),
      title: getState(elem, "title"),
      summary: getState(elem, "summary"),
      file: getState(elem, "file"),
      target: getState(elem, "target"),
      author: getState(elem, "author"),
    };

    const formData = new FormData();
    formData.append("cmd", "submitfile");
    formData.append("user_id", getSession("userID"));
    formData.append("title", getState(elem, "title"));
    formData.append("summary", getState(elem, "summary"));
    formData.append("target", getState(elem, "target"));
    formData.append("author", getState(elem, "author"));
    formData.append("affiliate", getState(elem, "affiliate"));
    formData.append("file", getState(elem, "file"));

    axios
      .post(ApiEndpoint + "/submit?q=doCP", formData, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");

          if (response?.data?.data != false) {
            if (response?.data?.data?.payment_inline > 0) {
              //alert(response?.data?.data?.payment_url)

              $(".paypal-frame").attr("src", response?.data?.data?.payment_url);
              $(".pp-website-link").attr(
                "href",
                response?.data?.data?.payment_url
              );

              setTimeout(function () {
                if (
                  response?.data?.data?.payment_url != "" &&
                  response?.data?.data?.payment_url != false &&
                  response?.data?.data?.payment_url != null &&
                  response?.data?.data?.payment_url != "undefined" &&
                  response?.data?.data?.payment_url != undefined
                ) {
                  $(".pp-overlay").removeClass("hidden");
                } else {
                  //DO Nothing
                }
              }, 3000);
            } else if (response?.data?.data?.payment_redirect > 0) {
              setTimeout(function () {
                window.location.href = response?.data?.data?.payment_url;
              }, 4000);
            } else {
              alert(
                "We have sent you a PayPal Payment instruction to your email address, please check your email to continue!"
              );
            }
          } else {
            setTimeout(function () {
              window.location.href = "/my-submission";
            }, 10000);
          }
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, submitError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doUpdateRole = async (elem) => {
  let DeviceSid = await FingerPrint();

  let updateError = "";
  let classError = "";

  if (getState(elem, "role") == "") {
    updateError = "Role is required";
  }

  if (updateError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "updaterole",
      user_id: getSession("userID"),
      role: getState(elem, "role"),
    };

    axios
      .post(ApiEndpoint + "/updaterole?q=doUpdateRole", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");
          //clearSession();
          setTimeout(function () {
            window.location.href = "/dashboard";
          }, 4000);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, updateError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doUpdateField = async (elem) => {
  let DeviceSid = await FingerPrint();

  let updateError = "";
  let classError = "";

  if (getState(elem, "division") == "") {
    updateError = "Field of specialization is required";
  }

  if (updateError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "updatefield",
      user_id: getSession("userID"),
      division: getState(elem, "division"),
    };

    axios
      .post(ApiEndpoint + "/updatefield?q=doUpdateField", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");
          //clearSession();
          setTimeout(function () {
            window.location.href = "/dashboard";
          }, 4000);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, updateError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doUpdateAccount = async (elem) => {
  let DeviceSid = await FingerPrint();

  let updateError = "";
  let classError = "";

  if (getState(elem, "email") == "") {
    updateError = "Email Address is required";
  } else if (getState(elem, "phone") == "") {
    updateError = "Phone number is required";
  } else if (getState(elem, "position") == "") {
    updateError = "Position is required";
  } else if (getState(elem, "institution") == "") {
    updateError = "Institution/Company is required";
  }

  if (updateError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "updateaccount",
      user_id: getSession("userID"),
      email: getState(elem, "email"),
      phone: getState(elem, "phone"),
      position: getState(elem, "position"),
      company: getState(elem, "institution"),
    };

    axios
      .post(ApiEndpoint + "/updateaccount?q=doUpdateAccount", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");
          //clearSession();
          setTimeout(function () {
            window.location.href = "/dashboard";
          }, 4000);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, updateError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doChangePassword = async (elem) => {
  let DeviceSid = await FingerPrint();

  let cpError = "";
  let classError = "";

  if (getState(elem, "oldpassword") == "") {
    cpError = "Old Password is required";
  } else if (getState(elem, "password") == "") {
    cpError = "Password is required";
  } else if (getState(elem, "password2") == "") {
    cpError = "Confirm Password is required";
  } else if (getState(elem, "password") !== getState(elem, "password2")) {
    cpError = "Password do not match";
  } else if (getState(elem, "password").length < 6) {
    cpError = "Password must be at least 6 characters long";
  }

  if (cpError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          getSession("token") +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "changepassword",
      user_id: getSession("userID"),
      oldpassword: getState(elem, "oldpassword"),
      password: getState(elem, "password"),
      password2: getState(elem, "password2"),
    };

    axios
      .post(ApiEndpoint + "/changepassword?q=doCP", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");
          clearSession();
          setTimeout(function () {
            window.location.href = "/dashboard";
          }, 4000);
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");

          if (
            response?.data?.logout == true &&
            response?.data?.token == false
          ) {
            setTimeout(function () {
              clearSession();
              window.location.href = "/login";
            }, 4000);
          }
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, cpError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doRecover = (elem) => {
  let recoverError = "";
  let classError = "";

  if (getState(elem, "userID") == "") {
    recoverError = "Enter your User ID it is required";
  } else if (getState(elem, "email") == "") {
    recoverError = "Enter your Email it is required";
  }

  if (recoverError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " + name + ", Session " + name + ", Platform " + platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "recover",
      user_id: getState(elem, "userID"),
      email: getState(elem, "email"),
    };

    axios
      .post(ApiEndpoint + "/recover?q=doRecover", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          AlertMessage(elem, response?.data?.message, "success");
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, recoverError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doReset = async (elem) => {
  let DeviceSid = await FingerPrint();

  let resetError = "";
  let classError = "";

  if (getState(elem, "userID") == "") {
    resetError = "User ID is required";
  } else if (getState(elem, "token") == "") {
    resetError = "Token is required";
  } else if (getState(elem, "password") == "") {
    resetError = "Password is required";
  } else if (getState(elem, "password2") == "") {
    resetError = "Confirm Password is required";
  } else if (getState(elem, "password") !== getState(elem, "password2")) {
    resetError = "Password do not match";
  } else if (getState(elem, "password").length < 6) {
    resetError = "Password must be at least 6 characters long";
  }

  if (resetError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          name +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "reset",
      user_id: getState(elem, "userID"),
      token: getState(elem, "userToken"),
      password: getState(elem, "password"),
      password2: getState(elem, "password2"),
    };

    axios
      .post(ApiEndpoint + "/reset?q=doReset", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          if (
            response?.data?.token != "" &&
            response?.data?.login_valid != "" &&
            response?.data?.login == true
          ) {
            AlertMessage(elem, response?.data?.message, "success");
            setSession("name", response?.data?.data?.name);
            setSession("userID", response?.data?.data?.user_id);
            setSession("region", response?.data?.data?.region);
            setSession("country", response?.data?.data?.country);
            setSession("level", response?.data?.data?.level);
            setSession("reviewer", response?.data?.data?.level);
            setSession("contractor", response?.data?.data?.contractor);
            setSession("editor", response?.data?.data?.editor);
            setSession("division", response?.data?.data?.division);
            //setSession('division_status', response?.data?.data?.division_status);
            setSession("SID", response?.data?.sid);
            setSession("Secure-SID", response?.data?.sid);
            setSession("token", response?.data?.token);
            setSession("Secure-token", response?.data?.token);
            setSession("session_id", response?.data?.session_id);
            setSession("Secure-session_id", response?.data?.session_id);
            setSession("login_id", response?.data?.login_id);
            setSession("Secure-login_id", response?.data?.login_id);
            setSession("session_oauth", response?.data?.session_oauth);
            setSession("Secure-session_oauth", response?.data?.session_oauth);
            setSession("timezone", response?.data?.timezone);
            setSession("login_valid", response?.data?.login_valid);
            setSession("login_valid_date", response?.data?.login_valid_date);
            setSession("login_time", response?.data?.login_time);
            //setSession('login_time2', Time());
            setSession("login_date", response?.data?.login_date);
            setSession("login", JSON.stringify(response?.data?.login));
            setSession("password", response?.data?.password);

            if (JSON.parse(response?.data?.login) === true) {
              setTimeout(function () {
                window.location.href = "/dashboard";
              }, 4000);
            }
          } else {
            AlertMessage(elem, response?.data?.message, "success");
            //AlertMessage(elem, 'Missing Token', 'error');
          }
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, resetError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doLogin = async (elem) => {
  let DeviceSid = await FingerPrint();

  let loginError = "";
  let classError = "";

  if (getState(elem, "userID") == "") {
    loginError = "User ID is required";
  } else if (getState(elem, "password") == "") {
    loginError = "Password is required";
  }

  if (loginError == "") {
    let header = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Bearer " +
          name +
          ", Session " +
          DeviceSid +
          ", Platform " +
          platform,
        "My-Custom-Header": name,
        "User-Agent": name + " Bot",
      },
    };

    let datas = {
      cmd: "login",
      user_id: getState(elem, "userID"),
      password: getState(elem, "password"),
    };

    axios
      .post(ApiEndpoint + "/login?q=doLogin", datas, header)
      .then((response) => {
        UpdateState(elem, "loading", "0");

        if (response?.data?.error == false && response?.data?.error != true) {
          if (
            response?.data?.token != "" &&
            response?.data?.login_valid != "" &&
            response?.data?.login == true
          ) {
            AlertMessage(elem, response?.data?.message, "success");
            setSession("name", response?.data?.data?.name);
            setSession("userID", response?.data?.data?.user_id);
            setSession("region", response?.data?.data?.region);
            setSession("country", response?.data?.data?.country);
            setSession("level", response?.data?.data?.level);
            setSession("reviewer", response?.data?.data?.level);
            setSession("contractor", response?.data?.data?.contractor);
            setSession("editor", response?.data?.data?.editor);
            setSession("division", response?.data?.data?.division);
            //setSession('division_status', response?.data?.data?.division_status);
            setSession("SID", response?.data?.sid);
            setSession("Secure-SID", response?.data?.sid);
            setSession("token", response?.data?.token);
            setSession("Secure-token", response?.data?.token);
            setSession("session_id", response?.data?.session_id);
            setSession("Secure-session_id", response?.data?.session_id);
            setSession("login_id", response?.data?.login_id);
            setSession("Secure-login_id", response?.data?.login_id);
            setSession("session_oauth", response?.data?.session_oauth);
            setSession("Secure-session_oauth", response?.data?.session_oauth);
            setSession("timezone", response?.data?.timezone);
            setSession("login_valid", response?.data?.login_valid);
            setSession("login_valid_date", response?.data?.login_valid_date);
            setSession("login_time", response?.data?.login_time);
            //setSession('login_time2', Time());
            setSession("login_date", response?.data?.login_date);
            setSession("login", JSON.stringify(response?.data?.login));
            setSession("password", response?.data?.password);
            setSession("div_message", response?.data?.data?.div_message);

            if (JSON.parse(response?.data?.login) === true) {
              setTimeout(function () {
                window.location.href = "/dashboard";
              }, 4000);
            }
          } else {
            AlertMessage(elem, "Missing Token", "error");
          }
        } else if (response?.data?.error != false) {
          AlertMessage(elem, response?.data?.error, "error");
        } else {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!",
            "error"
          );
        }
      })
      .catch((err) => {
        AlertMessage(
          elem,
          "Something went wrong, try again or try to reload the page!\n\r" +
            err,
          "error"
        );
        UpdateState(elem, "loading", "0");
      });
  } else {
    AlertMessage(elem, loginError, "error");
    UpdateState(elem, "loading", "0");
  }
};

export const doRegister = async (elem) => {
  $(".reg-btn").addClass("hide");
  $(".reg-loading").removeClass("hide");

  let registerError = "";
  let classError = "";

  if (getState(elem, "title") == "") {
    registerError = "Select your title it is required";
  } else if (getState(elem, "name") == "") {
    registerError = "Enter your Full name it is required";
  } else if (getState(elem, "email") == "") {
    registerError = "Enter your Email it is required";
  } else if (getState(elem, "email2") == "") {
    registerError = "Confirm your Email it is required";
  } else if (!validateEmail(getChange(elem, "email"))) {
    registerError = "Email address is invalid";
  } else if (!validateEmail(getChange(elem, "email2"))) {
    registerError = "Confirm Email address is invalid";
  } else if (getChange(elem, "email") !== getChange(elem, "email2")) {
    registerError = "Your Email address does not match";
  } else if (getState(elem, "phone") == "") {
    registerError = "Enter your Phone number it is required";
  } else if (getState(elem, "division") == "") {
    registerError = "Select your Field of Specialization it is required";
  } else if (getState(elem, "company") == "") {
    registerError = "Enter your Company it is required";
  } else if (getState(elem, "position") == "") {
    registerError = "Select your Position it is required";
  } else if (getState(elem, "terms") != "1") {
    registerError = "You must accept terms and condition to continue";
  } else if (
    getState(elem, "type") == "" ||
    getState(elem, "type") == undefined ||
    (getState(elem, "type") != "user" && getState(elem, "type") != "contractor")
  ) {
    registerError = "Unknown User Account Type" + getState(elem, "type");
  }

  if (registerError == "") {
    if (
      getState(elem, "country") == "" ||
      getState(elem, "geo_ip") == "" ||
      getState(elem, "region") == "" ||
      getState(elem, "regionID") == ""
    ) {
      registerError =
        "Something went wrong, try again. but if issue persist try to reload the page and try again";
    }
    if (registerError == "") {
      let header = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization:
            "Bearer " + name + ", Session " + name + ", Platform " + platform,
          "My-Custom-Header": name,
          "User-Agent": name + " Bot",
        },
      };

      let datas = {
        cmd: "register",
        title: getState(elem, "title"),
        name: getState(elem, "name"),
        email: getState(elem, "email"),
        email2: getState(elem, "email2"),
        phone: getState(elem, "phone"),
        division: getState(elem, "division"),
        company: getState(elem, "company"),
        company_number: getState(elem, "company_number"),
        company_address: getState(elem, "company_address"),
        position: getState(elem, "position"),
        geo_ip: getState(elem, "geo_ip"),
        country: getState(elem, "country"),
        region: getState(elem, "region"),
        region_id: getState(elem, "regionID"),
        type: getState(elem, "type"),
      };

      axios
        .post(ApiEndpoint + "/register?q=doRegister", datas, header)
        .then((response) => {
          UpdateState(elem, "loading", "0");

          if (response?.data?.error == false && response?.data?.error != true) {
            AlertMessage(elem, response?.data?.message, "success");
          } else if (response?.data?.error != false) {
            AlertMessage(elem, response?.data?.error, "error");
          } else {
            AlertMessage(
              elem,
              "Something went wrong, try again or try to reload the page!",
              "error"
            );
          }
        })
        .catch((err) => {
          AlertMessage(
            elem,
            "Something went wrong, try again or try to reload the page!\n\r" +
              err,
            "error"
          );
          UpdateState(elem, "loading", "0");
        });
    } else {
      AlertMessage(elem, registerError, "error");
      UpdateState(elem, "loading", "0");
    }
  } else {
    AlertMessage(elem, registerError, "error");
    UpdateState(elem, "loading", "0");
  }
};
